import { ContainerModule } from 'inversify';
import { domainModule } from '@/Framework/config/DI/domainModule';
import { configModules } from '@finsight/config/DI/configModules';
import { analyticsModule } from './modules/analyticsModule';

export const rootModules: ContainerModule[] = [
  domainModule,
  configModules,
  analyticsModule,
];
